const fieldsA = [
  'PDB_Backend_Servicevertrag',
  'PDB_Backend_ServicevertragVersandt',
  'PDB_Backend_OtrisLink',
  'PDB_Backend_DauerrechnungGemeldet',
  'PDB_Backend_ZugangZumLPMSErwuenscht',
  'PDB_Backend_Backend_UserAz',
  'PDB_Backend_NameUndEMail',
  'PDB_Backend_LadepunkteOeffentlich',
  'PDB_Backend_HaendlerportalZugangsEmails',
  'PDB_Backend_Ladestationsname_Fremd',
  'PDB_Backend_Type',
  'PDB_Backend_VerkaufskostensatzAC',
  'PDB_Backend_VerkaufskostensatzDC',
  'PDB_Backend_Authentifizierung',
  'PDB_Backend_AnzeigeInApp',
  'PDB_Backend_Roaming_Vermarkten',
  'PDB_Backend_Direct',
  'PDB_Backend_Kartenterminal',
  'PDB_Backend_Vorautorisierungsbetrag',
  'PDB_Backend_Zeittarif_AC',
  'PDB_Backend_Zeittarif_DC',
  'PDB_Backend_Waehrung',
  'PDB_Backend_Steuersatz',
  'PDB_Backend_SteuernummerDesKunden',
  'PDB_Backend_FirmennameDesKunden',
  'PDB_Backend_Firmenanschrift',
  'PDB_Backend_EODTime',
  'PDB_Backend_PCISO15118',
  'PDB_Backend_Geolokation_long',
  'PDB_Backend_Geolokation_lat',
]
const key = 'Backend'
const formGroupA = {
  key,
  form: key,
}

const fieldsSonstige = [
  'PDB_Backend_KundenBackend',
  'PDB_Backend_ZugangsdatenKundenBackend',
  'PDB_Backend_Chargebox_ID', // Chargebox ID Kunden-Backend
  'PDB_Backend_EVSEID_QRCode',
  'PDB_Backend_Roamingaktiv',
  'AC_Standort_Name',
  'DC_Standort_Name',
]
const keySonstige = 'Backend_Sonstige'
const formGroupSonstige = {
  key: keySonstige,
  title: keySonstige,
  form: keySonstige,
}

const fieldsMarketinginformationen = [
  'PDB_Backend_HotlineTyp',
  'PDB_Backend_HotlineRufnummerConnect',
  'PDB_Backend_HotlineRufnummerKunde',
  'PDB_Backend_AnzeigeInPortalen',
  'PDB_Backend_OeffnungszeitenUndZugang',
  'PDB_Backend_ExterneKartendienste',
]
const keyMarketinginformationen = 'Backend_Marketinginformationen'
const formGroupMarketinginformationen = {
  key: keyMarketinginformationen,
  title: keyMarketinginformationen,
  form: keyMarketinginformationen,
}

const fieldsTHGQuote = ['PDB_Backend_THGQuote']
const keyTHGQuote = 'Backend_THGQuote'
const formGroupTHGQuote = {
  key: keyTHGQuote,
  title: keyTHGQuote,
  form: keyTHGQuote,
}

const fieldsIdentifikationsmedien = [
  'PDB_Backend_Ident_BenoetigtIdentifikationsmediumConnect',
  'PDB_Backend_Ident_zustaendigerAP',
  'PDB_Backend_Ident_rueckerstattungKonto',
  'PDB_Backend_Ident_rueckerstattungGemeldet',
  'PDB_Backend_Ident_rueckerstattungBemerkung',
]
const keyIdentifikationsmedien = 'Backend_Identifikationsmedien'
const formGroupIdentifikationsmedien = {
  key: keyIdentifikationsmedien,
  title: keyIdentifikationsmedien,
  form: keyIdentifikationsmedien,
}

const fieldsIdent = [
  'ident_dienstwagen',
  'ident_dienstwagen_wo',
  'ident_dienstwagen_wie_dienstwagen',
  'ident_dienstwagen_wie_mieter',
  'ident_dienstwagen_app_erlauben',
  'ident_dienstwagen_EinsZuEins',
  'ident_dienstwagen_EinsZuEins_Beziehung',
  'ident_dienstwagen_zusatz',
  'ident_dienstwagen_rechnungsempfaenger',
  'ident_dienstwagen_rechnungsempfaenger_name',
  'ident_dienstwagen_rechnungsempfaenger_adresse',
  'ident_dienstwagen_rechnungsempfaenger_plz',
  'ident_dienstwagen_rechnungsempfaenger_stadt',
  'ident_dienstwagen_rechnungsempfaenger_email',
  'ident_dienstwagen_AP_name',
  'ident_dienstwagen_AP_email',
  'ident_dienstwagen_ladekartenBestellung',
  'ident_dienstwagen_sondertarief',

  'ident_privat',
  'ident_privat_wo',
  'ident_privat_wie',
  'ident_privat_EinsZuEins',
  'ident_privat_EinsZuEins_Beziehung',
  'ident_privat_zusatz',
  'ident_privat_rechnungsempfaenger',
  'ident_privat_AP_name',
  'ident_privat_AP_email',
  'ident_privat_ladekartenBestellung',
  'ident_privat_sondertarief',

  'ident_mieter',
  'ident_mieter_wie',
  'ident_mieter_EinsZuEins',
  'ident_mieter_EinsZuEins_Beziehung',
  'ident_mieter_zusatz',
  'ident_mieter_rechnungsempfaenger',
  'ident_mieter_AP_name',
  'ident_mieter_AP_email',
  'ident_mieter_ladekartenBestellung',
  'ident_mieter_sondertarief',

  'ident_vouchercodes',
  'ident_sonstige_infos',
]
const keyIdent = 'Backend_Ident'
const formGroupIdent = {
  key: keyIdent,
  title: keyIdent,
  form: keyIdent,
}


export const fieldOrderBackend = {
  [key]: { fields: fieldsA },
  [keySonstige]: { fields: fieldsSonstige },
  [keyMarketinginformationen]: { fields: fieldsMarketinginformationen },
  [keyTHGQuote]: { fields: fieldsTHGQuote },
  [keyIdentifikationsmedien]: { fields: fieldsIdentifikationsmedien },
  [keyIdent]: { fields: fieldsIdent },
}

export const formGroupBackend = {
  key,
  title: key,
  forms: [
    formGroupA,
    formGroupSonstige,
    formGroupMarketinginformationen,
    formGroupTHGQuote,
    formGroupIdentifikationsmedien,
    formGroupIdent,
  ],
}
